import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'dessert'})
export class DvlDessertPipe implements PipeTransform {
  transform(key: string, desserts: any[]): string {
    let dessert: any;
    let name: string = '';

    if (desserts) {
      dessert = desserts.find((dessert)=> dessert.$key === key);
      name = dessert ? dessert.name : '';
    }

    return name;
  }
}



// WEBPACK FOOTER //
// /Proyectos-Ankaa/proyecto-meriendas-diverland/src/app/pipes/dessert.pipe.ts